export default __webpack_public_path__ + "static/media/wpay.76ad0617.png";